import { Injectable, Injector } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionIdleMonitorService, TokenStorageService } from '../services';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
    constructor(
        public tokenStorageService: TokenStorageService,
        public router: Router,
        private injector: Injector,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let hasAuthHeader = false;

        if (req.headers.has('Authorization')) {
            if (req.headers.get('Authorization').toLowerCase() === 'none') {
                req = req.clone({ headers: req.headers.delete('Authorization') });
            } else if (req.headers.get('Authorization').toLowerCase().startsWith('bearer ')) {
                hasAuthHeader = true;
            }
        } else {
            const token = this.tokenStorageService.getValue();
            if (token) {
                req = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
                hasAuthHeader = true;
            }
        }

        // @TODO problem with formData body post
        if (!req.headers.has('Content-Type')) {
            if (req.url.includes('Tickets') && req.url.includes('Files') && req.method === 'POST') {
            } else {
                req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
            }
        }

        req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
        req = req.clone({ headers: req.headers.set('Environment', 'web') });
        const shouldTrackSessionActivity = hasAuthHeader && !this.isSessionLifecycleRequest(req);

        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse && shouldTrackSessionActivity) {
                    this.injector.get(SessionIdleMonitorService).registerRequestActivity();
                }
            }),
            catchError(err => {
                if (err.status === 403) {
                    // refresh
                    // this.tokenStorageService.removeValue();
                    this.router.navigate(['auth', 'login']);
                }

                return observableThrowError(err);
            }),
        );
    }

    private isSessionLifecycleRequest(req: HttpRequest<any>): boolean {
        return req.url.includes('/User/Session/Ping') || req.url.includes('/User/Logout');
    }
}
